export default __webpack_public_path__ + "static/media/video_yoga.f138d9cf.mp4";